import React from "react";
import HeaderSticky from "../../Partials/Header/HeaderSticky";
import Footer from "../../Partials/Footer/Footer";
import Body from "./Body";

export default class Home extends React.Component {
  render() {
    return (
      <div className="integrator-wrapper">
        <HeaderSticky className="start-header"/>
        <Body />
        <Footer />
      </div>
    );
  }
}